var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoProtectedRecording = function SvgIcoProtectedRecording(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "m12.185 1.027 8.63 2.59c.272.08.459.332.459.616v9.493c0 1.235-.5 2.498-1.486 3.756-.752.961-1.794 1.926-3.095 2.868a28 28 0 0 1-4.43 2.594.64.64 0 0 1-.526 0 28 28 0 0 1-4.43-2.594c-1.301-.942-2.343-1.907-3.095-2.868-.986-1.258-1.486-2.521-1.486-3.756V4.233c0-.284.187-.535.46-.617l8.629-2.589a.64.64 0 0 1 .37 0M12.096 8H9v8h1.763v-3.198h.87L13.305 16h2.113l-2.034-3.379q.848-.158 1.288-.745.441-.6.441-1.447 0-.7-.249-1.163a1.86 1.86 0 0 0-.655-.746 2.6 2.6 0 0 0-.96-.396A5 5 0 0 0 12.096 8m-.294 3.31h-1.04V9.493h1.153q.237 0 .486.033.25.034.44.136.193.09.317.271.125.18.125.486 0 .328-.147.509a.83.83 0 0 1-.35.27 1.8 1.8 0 0 1-.487.102q-.26.012-.497.012",
    clipRule: "evenodd"
  })));
};
export default SvgIcoProtectedRecording;